var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"rounded":""},on:{"click":function($event){return _vm.click()}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v(_vm._s(_vm.icon))]),_vm._v("\n\t"+_vm._s(_vm.$t(("common." + _vm.type)))+"\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }